import { Location } from '@angular/common';
import { Router, NavigationExtras } from '@angular/router';
import { GlobalFunction } from '../../common/core/global_function';
import { AuthenticateService } from '../../common/services/authenticate.service';
import { AppGlobal } from '../../common/app.global';

export function postLoginRedirect(
  location: Location,
  router: Router,
  appGlobal: AppGlobal,
  authenticateService: AuthenticateService
) : Promise<any> {
  let result: Promise<any>;
  if (GlobalFunction['temporary_password'] && localStorage.getItem('token')) {
    let backRoute = router.createUrlTree(['/authenticate/resetpassword']).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        urlb: location.prepareExternalUrl(backRoute)
      }
    };
    result = router.navigate(['/authenticate'], navigationExtras);
  }
  const object_search = GlobalFunction.searchToObject();
  const user_info = localStorage.getItem('user_info');
  if (user_info) {
    let userInfoObject = typeof (user_info) === 'string' ? JSON.parse(user_info) : user_info;
    let prefixUrlRole = userInfoObject ? GlobalFunction.getPrefixUrlRole(userInfoObject.role) : "";
    if (prefixUrlRole) {
      localStorage.setItem(appGlobal.prefixUrlRoleLocalKey, userInfoObject ? GlobalFunction.getPrefixUrlRole(userInfoObject.role) : "");
      localStorage.setItem(appGlobal.roleLocalKey, userInfoObject.role);
      localStorage.setItem(appGlobal.roleNameLocalKey, GlobalFunction.getListRole()[userInfoObject.role]);
      localStorage.setItem(appGlobal.emailCurrentUserLoginLocalKey, userInfoObject.username);
      localStorage.setItem(appGlobal.schoolCurrentUserLoginLocalKey, userInfoObject.school);

      appGlobal.prefixUrlRole = localStorage.getItem(appGlobal.prefixUrlRoleLocalKey);
      appGlobal.roleName = localStorage.getItem(appGlobal.roleNameLocalKey);
      appGlobal.role = parseInt(localStorage.getItem(appGlobal.roleLocalKey));
      appGlobal.emailCurrentUserLogin = localStorage.getItem(appGlobal.emailCurrentUserLoginLocalKey);
      appGlobal.schoolCurrentUserLogin = localStorage.getItem(appGlobal.schoolCurrentUserLoginLocalKey);

      if (object_search['urlb']) {
        window.location.href = object_search['urlb'];
      } else {
        result = router.navigate(['/' + encodeURIComponent(prefixUrlRole) + '/dashboard/index']);
      }
    } else {
      result = authenticateService.logout().then(() => {
        return router.navigate(['/authenticate']);
      });
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/app/common/core/utils.ts